export default {"src":"/_next/static/media/quote4.e709c59d.svg","height":77,"width":99,"blurWidth":0,"blurHeight":0};